import axios, { type AxiosError, type AxiosResponse } from 'axios';

const apiClient = axios.create({
  withCredentials: true,
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        // Lazy import to avoid a circular dependency (axios -> router -> services -> axios)
        void import('@/router').then(({ default: router }) => {
          if (router.currentRoute.value.name !== 'Login') {
            router.push({ name: 'Login' });
          }
        });
      }

      if (data && !(data as Record<string, unknown>).error) {
        error.response.data = {
          error: {
            statusCode: (data as Record<string, unknown>).statusCode || status,
            message: (data as Record<string, unknown>).message || 'An error occurred',
            name: (data as Record<string, unknown>).error || 'Error',
            details: (data as Record<string, unknown>).details || null,
            timestamp: (data as Record<string, unknown>).timestamp,
            path: (data as Record<string, unknown>).path,
          },
        } as unknown;
      }
    } else if (error.request) {
      console.error('Network error:', error.message);
      error.response = {
        data: {
          error: {
            statusCode: 0,
            message: 'Network error. Please check your connection.',
            name: 'NetworkError',
          },
        },
      } as AxiosResponse;
    } else {
      console.error('Request setup error:', error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
